import { render, staticRenderFns } from "./ProviderIconSquare.vue?vue&type=template&id=e727fb34&scoped=true"
import script from "./ProviderIconSquare.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProviderIconSquare.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProviderIconSquare.vue?vue&type=style&index=0&id=e727fb34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e727fb34",
  null
  
)

export default component.exports